import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import ContactForm from "./Components/ContactForm";
import styled from "styled-components";
import { motion } from "framer-motion";

function Inquire() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      window.innerWidth > 1200 ? setIsMobile(false) : setIsMobile(true);
    };
    window.innerWidth > 1200 ? setIsMobile(false) : setIsMobile(true);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Wrapper>
      <TopImage></TopImage>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          backgroundColor: "#FDFEFF",
          borderRadius: 25,
          width: isMobile ? "95%" : 500,
          marginTop: "-80vh",
          marginRight: "auto",
          marginLeft: "auto",
          boxShadow: "0 22px 50px rgba(0,0,0,0.14)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <AmbientGlow />
        <Title>Let’s dream up your next session together</Title>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 0,
            marginBottom: 20,
            position: "relative",
            zIndex: 1,
          }}
        >
          <a
            href="https://www.instagram.com/rainbowtroutreverie/"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              flexDirection: "row",
              margin: "10px auto",
              color: "black",
              width: 280,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px auto",
              }}
            >
              <FontAwesomeIcon
                icon={faInstagram}
                color="#ADA98D"
                size="2x"
                style={{ marginRight: 5 }}
              />
              <p style={{ margin: "auto", color: "#ADA98D" }}>
                @RainbowTroutReverie
              </p>
            </div>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100095246892706&mibextid=LQQJ4d"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              flexDirection: "row",
              margin: "10px auto",
              color: "black",
              width: 280,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px auto",
              }}
            >
              <FontAwesomeIcon
                icon={faFacebook}
                color="#ADA98D"
                size="2x"
                style={{ marginRight: 5 }}
              />
              <p style={{ margin: "auto", color: "#ADA98D" }}>
                @RainbowTroutReverie
              </p>
            </div>
          </a>
          <a
            href="https://www.gmail.com"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              flexDirection: "row",
              margin: "10px auto",
              color: "black",
              width: 280,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px auto",
              }}
            >
              <FontAwesomeIcon
                icon={faEnvelope}
                color="#ADA98D"
                size="2x"
                style={{ marginRight: 5 }}
              />
              <p style={{ margin: "auto", color: "#ADA98D" }}>
                LexiLakotaPhotography@gmail.com
              </p>
            </div>
          </a>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{ position: "relative", zIndex: 1 }}
        >
          <ContactForm />
        </motion.div>
      </motion.div>
    </Wrapper>
  );
}
export default Inquire;

const Title = styled.h1`
  font-size: 2em;
  font-weight: 300;
  color: #ada98d;
  cursor: pointer;
`;

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  overflow-x: hidden;
`;

const TopImage = styled.section`
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  background-image: url(${"https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/bioBackground.webp"});

  background-size: cover; /* Adjust as needed */
  background-position: center; /* Adjust as needed */
  background-repeat: no-repeat; /* Adjust as needed */
  width: 100%; /* Example dimensions */
  height: 100vh; /* Example dimensions */
  width: 100%;
`;

const AmbientGlow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(255, 191, 158, 0.18), transparent 40%),
    radial-gradient(circle at 80% 10%, rgba(173, 169, 141, 0.24), transparent 42%);
  filter: blur(10px);
  z-index: 0;
`;
